import type { ButtonHTMLAttributes, ReactElement } from "react";
import styles from "./Button.module.css";

export type ButtonVariant = "primary" | "secondary" | "ghost";
export type ButtonSize = "sm" | "md" | "lg";

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
  size?: ButtonSize;
  /** Stretch to fill the inline axis of its container. */
  fullWidth?: boolean;
}

/**
 * The primary action control. Always a real `<button>` (keyboard- and
 * screen-reader-native); `type` defaults to `button` so it never submits a
 * form by accident. Meets the 44px WCAG 2.2 target size via a component token.
 */
export function Button({
  variant = "primary",
  size = "md",
  fullWidth = false,
  type = "button",
  className,
  children,
  ...rest
}: ButtonProps): ReactElement {
  const classes = [
    styles.button,
    styles[variant],
    size !== "md" ? styles[size] : undefined,
    fullWidth ? styles.fullWidth : undefined,
    className,
  ]
    .filter(Boolean)
    .join(" ");
  return (
    <button type={type} className={classes} {...rest}>
      {children}
    </button>
  );
}
